import { NewNewsContext, NewNewsValues } from 'context'
import * as React from 'react'

export function useNewNewsContext() {
  return React.useContext<NewNewsValues>(NewNewsContext)
}
